module.exports = __webpack_public_path__ + "static/img/letterhead_accreditation.da121e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/letterhead_accreditation.png
// module id = jPax
// module chunks = 8